import styled from "styled-components";

export const InfoCard = styled.li`
  border: 2px solid #104467;
  border-radius: 20px;
  width: 300px;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  padding: 30px;
  gap: 15px;
`;

export const CardItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  color: #104467;
`;

export const CardTypeDiv = styled.div`
  background-color: rgb(245, 245, 245);
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  color: #104467;
`;

export const TopBarActions = styled.div`
  height: 25px;
  display: flex;
  gap: 5px;
`;

export const IconContainer = styled.div`
  background-color: blanchedalmond;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;

export const CardType = styled.span`
  color: #104467;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 1rem;
`;

export const CardTitle = styled.h3`
  font-size: 1.25rem;
  color: #104467;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const CardGroupDiv = styled.div`
  gap: 5px;
  display: flex;
  flex-direction: column;
`;

export const CardUniversity = styled.span`
  color: #104467;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const CardRowWithIcon = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

export const CardRow = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  overflow-wrap: break-word;
  color: #104467;
  font-weight: 500;
`;
